import { render, staticRenderFns } from "./create-or-edit-edition.vue?vue&type=template&id=092ff0da"
import script from "./create-or-edit-edition.vue?vue&type=script&lang=js"
export * from "./create-or-edit-edition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports